import { Image, Tag, Typography } from "antd";
import pdflogo from "../assets/images/download.svg"
import text from "../assets/images/text.svg"
import zip from "../assets/images/zip.svg"
import xlsx from "../assets/images/xlsx.svg"
import xls from "../assets/images/xls.svg"
import CSV from "../assets/images/CSV.svg"
import doc from "../assets/images/microsoft-word-2013-logo-logo.svg"
import moment from "moment";
import { DeleteOutlined } from '@ant-design/icons';

export default function FileItem({ file, allowDelete = false, deleteClicked, variant = "default" }) {

    const handleFileClick = async (file) => {
        window.open(file.path, '_blank', 'noopener,noreferrer');
    };

    let name = file?.name.split('.');
    let ext = name[name.length - 1];

    // Different styles based on variant
    const isDriveVariant = variant === "drive";
    const tagStyle = isDriveVariant ? {
        padding: '16px',
        borderRadius: '12px',
        maxWidth: '220px',
        minWidth: '200px',
        minHeight: '180px',
        marginLeft: '0px',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    } : {
        padding: '9px',
        borderRadius: '5px',
        maxWidth: '180px',
        marginLeft: '110px',
        position: 'relative',
    };

    const imageHeight = isDriveVariant ? 80 : 50;
    const iconHeight = isDriveVariant ? 70 : 50;

    return (
        <Tag
            className='pointer mx-2 my-1'
            style={tagStyle}
        >
            <div className="d-flex flex-column" style={{ height: '100%' }}>
                {(file?.type === "image/jpeg" || file?.type === "image/png" || file?.type === "image/jpg") ?
                    <Image
                        src={file?.path}
                        height={imageHeight}
                        width={"100%"}
                        style={{
                            objectFit: "cover",
                            borderRadius: isDriveVariant ? '8px' : '4px',
                            marginBottom: isDriveVariant ? '12px' : '8px'
                        }}
                    /> : null
                }
                <div className="d-flex flex-column" onClick={() => handleFileClick(file)} style={{ flex: 1 }}>
                    {(ext === "doc" || ext === 'docx') ?
                        <Image preview={false} height={iconHeight} src={doc} style={{ marginBottom: isDriveVariant ? '12px' : '8px' }} /> : null
                    }
                    {(ext === "txt") ?
                        <Image preview={false} height={iconHeight} src={text} style={{ marginBottom: isDriveVariant ? '12px' : '8px' }} /> : null
                    }
                    {(ext === "xlsx") ?
                        <Image preview={false} height={iconHeight} src={xlsx} style={{ marginBottom: isDriveVariant ? '12px' : '8px' }} /> : null
                    }

                    {(ext === "xls") ?
                        <Image preview={false} height={iconHeight} src={xls} style={{ marginBottom: isDriveVariant ? '12px' : '8px' }} /> : null
                    }

                    {(ext === "csv") ?
                        <Image preview={false} height={iconHeight} src={CSV} style={{ marginBottom: isDriveVariant ? '12px' : '8px' }} /> : null
                    }
                    {(ext === "zip") ?
                        <Image preview={false} height={iconHeight} src={zip} style={{ marginBottom: isDriveVariant ? '12px' : '8px' }} /> : null
                    }
                    {(ext === "pdf") ?
                        <Image preview={false} height={iconHeight} src={pdflogo} style={{ marginBottom: isDriveVariant ? '12px' : '8px' }} /> : null
                    }

                    <div className='d-flex' style={{ marginBottom: isDriveVariant ? '8px' : '4px' }}>
                        <div
                            className='elipText'
                            style={{
                                fontSize: isDriveVariant ? '14px' : '12px',
                                fontWeight: isDriveVariant ? '500' : 'normal',
                                lineHeight: isDriveVariant ? '1.4' : '1.2'
                            }}
                        >
                            {decodeURIComponent(file?.name)}
                        </div>
                        <div
                            className='elipText'
                            style={{
                                maxWidth: isDriveVariant ? "60px" : "50px",
                                fontSize: isDriveVariant ? '12px' : '11px',
                                color: isDriveVariant ? '#666' : '#888'
                            }}
                        >
                            .{ext}
                        </div>
                    </div>

                    <Typography.Text
                        style={{
                            fontSize: isDriveVariant ? '12px' : '11px',
                            color: isDriveVariant ? '#888' : '#999',
                            marginTop: 'auto'
                        }}
                    >
                        {moment.utc(file?.createdAt).format("DD MMM YYYY HH:mm")}
                    </Typography.Text>
                </div>
            </div>
            {
                allowDelete ?
                    <div style={{
                        position: 'absolute',
                        top: '0',
                        right: '0',
                        transform: 'translate(30%, -30%)',
                        zIndex: 1,
                        backgroundColor: '#1890ff',
                        borderRadius: '50%',
                    }}>

                        <DeleteOutlined
                            style={{
                                color: 'white',
                                fontSize: isDriveVariant ? '20px' : '18px',
                                padding: isDriveVariant ? '6px' : '5px',
                            }}
                            onClick={deleteClicked}
                        />
                    </div>
                    : null
            }
        </Tag>
    )
}